import { ThemeProvider as BaseThemeProvider } from "next-themes"
import type { ThemeProviderProps } from "next-themes"

export function ThemeProvider({ children, ...props }: ThemeProviderProps) {
	return <BaseThemeProvider {...props}>{children}</BaseThemeProvider>
}
